import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid, parseOptions, getParam} from '../question-helper';
import { GlobalQuestionService } from '../../services/global-question.service';
import { QuestionQuery } from '../state/question.query';
import { ComponentsService } from '../../services/components-service';

@Component({
    selector: 'app-question-reg-vin',
    templateUrl: './question-reg-vin.component.html',
    styleUrls: ['./question-reg-vin.component.scss'],
    standalone: false
})
export class QuestionRegVinComponent implements OnInit, OnChanges {

  @Input() question: Question;
  @Input() readOnly = false;
  @Input() isEdit = false;
  @Output() questionAnswer = new EventEmitter();
  @Output() selectedOption = new EventEmitter();
  @Output() parentQuestionAnswer = new EventEmitter();

  uniqueControlName = `reg-vin-name-${newGuid()}`;
  items: any[] = [];
  skipped = false;
  showSkip = false;
  parameter: any;
  questions: Question[];
  parent_id = 0;
  additionalQuestion = false;
  childrenQuestions: any[] = [];
  constructor(private questionService: GlobalQuestionService,
    private componentsService: ComponentsService
    ) { }

  ngOnInit(): void {
  
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes?.question?.currentValue;
      this.getChildrenQuestion();
     }
    
  }
 getChildrenQuestion(): void {
    this.questionService.spinner(true);
    this.questionService.getChildrenQuestions(this.question?.cent_aq_question_id)
      .subscribe((items: Question[]) => {
        this.childrenQuestions = [];
        for (const q of items) {
          if (!this.childrenQuestions.some(c => c.cent_aq_question_id === q.cent_aq_question_id)) {
            this.childrenQuestions.push(Object.assign({}, q));
          }
        }
        this.questionService.spinner(false);
        
      });
  }
  setAnswer(question: any, event: any): void {
    if (!this.isEdit) {
      this.childrenQuestions.forEach(q => {
        q.answer = 'Not Provided';
      });
    }
    this.childrenQuestions.find(q => q.cent_aq_question_id === question.cent_aq_question_id).answer = event.target.value.toUpperCase();
    
    this.question.answer = 'Answered';
    this.parentQuestionAnswer.emit(this.childrenQuestions);
    
  }
  
  checkRadio(option: any): void {
    if (option?.cent_aq_question_id === 4531) {
      if (!this.isEdit) {
        this.childrenQuestions.forEach(q => {
          q.answer = 'Not Provided';
        });
      }
      this.childrenQuestions.find(q => q.cent_aq_question_id === option.cent_aq_question_id).answer = option.question_prompt;
      console.log(this.childrenQuestions);
      this.parentQuestionAnswer.emit(this.childrenQuestions);
    }

  }
  isChecked(option: any): boolean {
    let isChecked = false;
    if (option?.cent_aq_question_id === 4531) {
      if (this.childrenQuestions.find(q => q.cent_aq_question_id === option.cent_aq_question_id)?.answer === option.question_prompt) {
        isChecked = true;
      }
    } else {
      if (this.childrenQuestions.find(q => q.cent_aq_question_id === option.cent_aq_question_id)?.answer && this.childrenQuestions.find(q => q.cent_aq_question_id === option.cent_aq_question_id)?.answer !== 'Not Provided') {
        isChecked = true;
      }
    }
    return isChecked;
  }
  
  showTextbox(q: any): boolean {
    let show = true;
    let param = null;
    if (q.parameter) {
      try {
        param = JSON.parse(q.parameter);
      } catch (e) { }
    }
    if (getParam(param, 'enable_textbox')?.value === '0') {
      show = false;
    }
    return show;
  }
    
}
